import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function Application_of_GIS_Page() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>APPLICATION OF GIS IN AGRO-RESIDUE BIOENERGY PLANNING</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The &nbsp;whole supply chain of a bioenergy project can &nbsp;be
              &nbsp;divided into three major spatially interlinked elements: (i)
              resource assess- ment, (ii) logistic planning, and (iii) power
              plant design. GIS inter- vention in &nbsp;bioenergy planning
              is&nbsp; necessary because: (i) &nbsp;diverse varieties of
              agro-residues are &nbsp;used as &nbsp;energy feedstock, therefore
              maintaining their spatio-temporal database concerning physico-
              chemical characteristics, availability and distribution is
              important. GIS helps in &nbsp;managing such database which later
              can &nbsp;guide the industries for &nbsp;effective collection of
              &nbsp;raw &nbsp;material, &nbsp;allocation of the benefits of
              &nbsp;bioenergy and cost-benefits analysis (Long &nbsp;et
              al.,2013; Alfonso et al., 2009). Periodic updating of the biomass
              inven- tories is also &nbsp;necessary to assess future feedstock
              supply potential; (ii) ensuring sustained feedstock supply is
              critical for &nbsp;viable com- missioning of &nbsp;a &nbsp;power
              plant. Prior &nbsp;knowledge of &nbsp;any &nbsp;fluctuation
              in&nbsp;&nbsp; feedstock supply would&nbsp; allow the &nbsp;user
              &nbsp;to&nbsp; &nbsp;make &nbsp;necessary arrangement for
              &nbsp;alternative feedstock supply during lean period of
              &nbsp;supply and it &nbsp;can&nbsp; &nbsp;be &nbsp;indicated
              through GIS (Stephen et &nbsp;al., 2010); (iii) consideration of
              the environmental requirement of resi- due and harvest
              constraints, economy, technology, competing uses of residue, local
              &nbsp;socio-political dynamic, land use, &nbsp;logistic
              facilities, civil &nbsp;and industrial users can &nbsp;also
              &nbsp;be &nbsp;assessed with GIS (Alfonso et al., &nbsp;2009;
              Beccali &nbsp;et al., &nbsp;2009; Gomez et al., &nbsp;2010; Jiang
              &nbsp;et al., 2012).
            </p>
            <p>
              The&nbsp; uneven geographical distribution of agro-residue demands
              proper logistic planning for the collection and transfer of
              residue in a time and cost-efficient manner. The &nbsp;various
              parties involved in the biomass supply chain that influence the
              final &nbsp;bioenergy cost include the supplier of &nbsp;biomass,
              transportation and distribution entities, energy production
              facility developers and operators, gov- ernment and utility firms
              and the end users (Mafakheri and Nasiri, 2014). The&nbsp;
              implementation of a spatial network can &nbsp;help the par- ties
              &nbsp;involved in bioenergy planning to act&nbsp; in a common
              framework by sharing costs, logistics, and personnel (Beccali et
              al., 2009). The rising competition for &nbsp;production areas, raw
              materials and infras- tructure also &nbsp;demands spatially
              explicit logistic planning (Fiedler et al., 2007).
            </p>
            <p>
              Among the &nbsp;logistic parameters,
              &nbsp;transportation&nbsp;&nbsp; can&nbsp; &nbsp;be&nbsp;
              &nbsp;cost intensive depending upon the distance and mode of
              transport (rail- way, &nbsp;roadway, waterway), nature of the
              feedstock (loose or dense) and the condition of the transport
              route. Optimization of the trans- portation network can
              &nbsp;significantly reduce the cost &nbsp;of &nbsp;transport. GIS
              &nbsp;has&nbsp; &nbsp;the &nbsp;capability to&nbsp;&nbsp; model
              least-cost transport &nbsp;pathway (Perpina et&nbsp; al.,
              &nbsp;2009; Ebadian et &nbsp;al., &nbsp;2011; Jiang&nbsp; &nbsp;et
              al., &nbsp;2012; Hiloidhari et al., &nbsp;2012). For
              &nbsp;example, Network Analyst extension of &nbsp;ArcGIS
              &nbsp;software can&nbsp; &nbsp;model least-cost transport
              &nbsp;pathway&nbsp; for delivering biomass feedstock from source
              to user location. It allows one &nbsp;to &nbsp;perform multiple
              network-based spatial functions such as identification &nbsp;of
              &nbsp;optimal/shortest&nbsp;&nbsp; route, &nbsp;closest
              &nbsp;facility, service area, origin-destination&nbsp; analysis
              (Perpina et &nbsp;al., &nbsp;2009). Further, transporting
              &nbsp;compacted &nbsp;(baled) biomass reduces&nbsp; cost&nbsp;
              &nbsp;and CO2 emission, even for &nbsp;short distances by
              &nbsp;allowing higher amount to be &nbsp;carried (Alfonso et al.,
              2009).
            </p>
            <p>
              Another logistic parameter that requires managerial attention is
              the selection of optimal biomass collection area and power plant
              site, &nbsp;where multiple factors come into play. &nbsp;Selecting
              optimal bio- mass collection areas should be &nbsp;in
              &nbsp;accordance with existing agri- cultural,&nbsp; geographical
              and &nbsp;infrastructural &nbsp;characteristics &nbsp;of &nbsp;the
              area &nbsp;encompassing &nbsp;supply &nbsp;and &nbsp;user
              &nbsp;locations &nbsp;(Beccali et &nbsp;al., 2009). The site
              &nbsp;should be easily accessible by transport route, near to
              utility points, feasible for the optimum planning of power trans-
              mission lines (Zubaryeva et al., 2012). Further, the plant should
              be installed &nbsp;in&nbsp;&nbsp; reasonable distance from
              residential areas, nature reserves to minimize potential negative
              impacts of plant operation and waste disposal. Beccali &nbsp;et
              al. (2009) developed a GIS method to assess the techno-economic
              potential of biomass for energy gener- ation in Sicily through
              identification of efficient transportation net- work and optimal
              biomass collection areas. Similarly, Fiedler et al. (2007)
              designed a GIS logistic model for cost &nbsp;efficient supply of
              bio- mass feedstock to industrial units by analyzing the
              profitability of investment in infrastructure and equipment for
              biomass supply.
            </p>
            <p>
              GIS &nbsp;based biomass power&nbsp; plant &nbsp;site&nbsp;
              &nbsp;selection can&nbsp; &nbsp;be&nbsp; &nbsp;done through two
              methods: (i) suitability analysis (ii) optimally analysis as
              elaborated by Shi et al. (2008). Suitability analysis allows user
              to identify the most suitable site &nbsp;for a power plant among
              many can- didate sites, based on &nbsp;user defined constrain and
              supportive crite- ria.&nbsp;&nbsp; &nbsp;On&nbsp;&nbsp;
              &nbsp;the&nbsp;&nbsp; other &nbsp;hand, &nbsp;optimally
              &nbsp;analysis &nbsp;considers &nbsp;the relationship between
              biomass and power plants in &nbsp;order to &nbsp;find the optimal
              power plant locations at minimum transportation cost. The&nbsp;
              optimization of biomass power plant location could be &nbsp;done
              either through location-allocation modelling or &nbsp;supply-area
              mod- elling. Using the optimally analysis approach, Shi et al.
              (2008) iden- tified potential &nbsp;sites &nbsp;for&nbsp;
              &nbsp;biomass&nbsp; power &nbsp;plants &nbsp;in&nbsp;
              &nbsp;Guangdong Province, China, &nbsp;considering the cost
              &nbsp;of transportation as &nbsp;a prime determining factor in
              developing bioenergy plant.
            </p>
            <p>
              Logistic&nbsp;&nbsp; planning for &nbsp;biomass collection can
              &nbsp;be &nbsp;further influ- enced by the type of land holding.
              For example, in India and China, due to &nbsp;small
              agricultural&nbsp; landholding by &nbsp;the &nbsp;farmer,
              collecting agro-residue biomass from farmland may be&nbsp;
              complicated com- pared to the Western countries (Yu et al., 2012).
              For the same col- lection radius, the collectors have to
              &nbsp;deal with a larger number of farmers,&nbsp; with
              &nbsp;organized &nbsp;logistic of &nbsp;contracting, collection
              and transportation (Yu et al., 2012). In a long &nbsp;supply
              chain, distributed biomass receiving stations (satellite storage)
              must be optimized for least cost &nbsp;delivery of biomass as
              reported by Yu et al. (2012). How- ever, &nbsp;Gomez et al. (2010)
              reported that, the size &nbsp;of a collection area produces two
              counteracting effects on the final &nbsp;cost &nbsp;of energy gen-
              erated. A large biomass collection area results in &nbsp;higher
              power plant &nbsp;capacity, making the &nbsp;power&nbsp; plant
              &nbsp;economically reliable, but, it &nbsp;increases the
              transportation&nbsp; costs of &nbsp;the biomass to &nbsp;the
              plant. Therefore, the authors (Gomez et al., 2010) have suggested
              that, in a large scale study with large geographical biomass
              supply area (e.g. &nbsp;country, province), it is impractical to
              &nbsp;optimize the size and location of &nbsp;every possible
              plant. But &nbsp;the better option is &nbsp;to use &nbsp;the same
              collection area for the whole of the territory and size of this
              area is &nbsp;to &nbsp;be &nbsp;determined in &nbsp;a&nbsp; way
              &nbsp;to &nbsp;fulfil &nbsp;the individual plant&rsquo;s minimum
              installed capacity (Gomez et al., 2010).
            </p>
            <p>
              Egbendewe-Mondzozo et al. (2011) proposed a spatial bioeco- nomic
              model, an &nbsp;integration of biophysical -GIS- economic regio-
              nal &nbsp;mathematical optimization model to &nbsp;estimate
              biomass supply from cellulosic crops and crop residues. The&nbsp;
              GIS part provides the transportation parameters to &nbsp;the
              bioeconomic model. Overall, the model can &nbsp;predict how
              biomass supply and environmental conse- quences respond to changes
              in genetic and biological management as well &nbsp;as market
              prices and government policy. Similarly, J. Singh et al. (2011)
              developed a GIS model for agro-residue based decen- tralized
              biomass power plant design at development block level &nbsp;in
              Punjab, India, &nbsp;which can &nbsp;be useful to decide optimum
              power plant locations with minimum storage and handling cost
              &nbsp;of feedstocks. GIS application has &nbsp;also &nbsp;been
              found suitable for village level &nbsp;small scale energy planning
              (Hiloidhari and Baruah, 2011; Kaundinya et al., 2013). Table
              &nbsp;1 summarizes selected numbers of recent GIS based bioenergy
              study.
            </p>
            <p style={{ textAlign: "center" }}>
              <img
                src="https://wgbis.ces.iisc.ac.in/energy/paper/Emerging-role-of-Geographical-Information-System/T1.png"
                alt=""
                width="975"
                height="343"
              />
            </p>
            <h3>
              Issues needing attention while using GIS for &nbsp;bioenergy
              planning
            </h3>
            <p>
              Some &nbsp;issues that could impact the quality of the GIS outputs
              are discussed below:
            </p>
            <p>
              (i) &nbsp;Pre &nbsp;and post -GIS &nbsp;analysis field&nbsp;&nbsp;
              visits to &nbsp;random sample areas are&nbsp;&nbsp; important to
              &nbsp;ascertain the accuracy of &nbsp;the GIS mapping. Systemic
              accuracy assessment&nbsp; using standard methods such as
              &nbsp;computation of &nbsp;error matrix (also called as
              &nbsp;confusion matrix) &nbsp;can&nbsp; &nbsp;increase the&nbsp;
              preciseness of &nbsp;the GIS output. Bioenergy planning which
              involves land use &nbsp;land cover mapping, the minimum mapping
              accuracy should be 85% (Foody, 2002).
              <br />
              (ii) &nbsp;The usefulness of the GIS output is influenced by the
              quality of satellite/digital image used for analysis. For example,
              good quality land use&nbsp; &nbsp;land cover map can&nbsp;
              &nbsp;be &nbsp;generated&nbsp; using medium &nbsp;resolution image
              (e.g. &nbsp;LISS-III satellite &nbsp;image &nbsp;of 23.5&nbsp;
              meter &nbsp;spatial &nbsp;resolution). &nbsp;However,&nbsp;
              &nbsp;to &nbsp;map &nbsp;cost- efficient road network for biomass
              transportation, high res- olution image is necessary (e.g.
              &nbsp;LISS-IV image of 5.8 meter spatial resolution) to
              &nbsp;extract all &nbsp;the details of &nbsp;the major and minor
              roads of a study area.
              <br />
              (iii) &nbsp;Precise image processing in &nbsp;terms of
              georeferencing, radio- metric &nbsp;calibration, &nbsp;noise
              &nbsp;removal,&nbsp; image &nbsp;enhancement, post-classification
              smoothening are &nbsp;other necessary require- ments to
              &nbsp;achieve higher mapping accuracy.
              <br />
              (iv) &nbsp;The &nbsp;choice of image classification method (manual
              vs. digi- tal) &nbsp;can &nbsp;also &nbsp;influence the quality of
              the GIS products.
            </p>
            <p>
              Therefore, careful consideration of the above points prior to ini-
              tiating the GIS mapping is essential for precise bioenergy
              planning.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default Application_of_GIS_Page;
